import { Stack } from "@mui/material";
import FormikDateMetaFields from "@poseidon/ui/components/form/FormikDateMetaFields";
import { BasicDetailFields } from "./BasicDetailFields";
import { BoatSpecificationFields } from "./BoatSpecificationFields";
import { BoatFormWrapper } from "./BoatFormWrapper";

export default function BoatForm({ boat, title }) {
  return (
    <>
      <BoatFormWrapper boat={boat} title={title}>
        <BasicDetailFields />
        <BoatSpecificationFields />
      </BoatFormWrapper>
      <Stack spacing={5} sx={{ px: 5, mb: 5 }}>
        <FormikDateMetaFields values={boat} />
      </Stack>
    </>
  );
}
